import { library } from '@fortawesome/fontawesome-svg-core';

import { faEnvelope, faFileExcel, faHome } from '@fortawesome/free-solid-svg-icons';

library.add(faEnvelope, faFileExcel, faHome);



// WEBPACK FOOTER //
// ./resources/js/core/structure/navbar/icons/enso.js